import { Component, OnInit, Inject, HostListener } from "@angular/core";
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl,
} from "@angular/forms";


import { UserService } from "src/app/Services/user.service";
import { threadId } from "worker_threads";
import { Router } from "@angular/router";
//import { LoggerService } from "src/app/Services/Logger/Logger";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DgHubClientService } from "src/app/Services/dg-hub-client.service";
import { CookiesService } from "src/app/Services/cookieService";

@Component({
  selector: "app-login",
  templateUrl: "./dialog.login.component.html",
  styleUrls: ["./dialog.login.component.css"],
})
export class DialogLoginComponent implements OnInit {
  loginForm = this.fb.group({
    email: [null, Validators.required],
    password: [null, Validators.required],
    rememberme: [true],
  });
  url = "";
public message:string='';
  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private hubClientService: DgHubClientService,
    public route: Router,
    private cookieService: CookiesService,
    public dialogRef: MatDialogRef<DialogLoginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data && this.data.email && this.data.email !== "undefined") {
      this.loginForm.controls["email"].setValue(this.data.email);
    }
    if (this.data && this.data.password) {
      this.loginForm.controls["password"].setValue(this.data.password);
    }

    if (this.data && this.data.rememberme) {
      this.loginForm.controls["rememberme"].setValue(this.data.rememberme);
    }

    if (this.data && this.data.url) {
      this.url = this.data.url;
    }

    switch(this.data.error)
        {
          case "Subscription_Ended":
            this.message = "Your Subscription has ended.";
            this.loginForm.controls["email"].setValue( this.hubClientService.lastLogin) ;
          break;

          case "Login_Error":
            this.message = "Incorrect user or password";
            this.loginForm.controls["email"].setValue( this.hubClientService.lastLogin) ;
          break;

          case "BAD_TOKEN":
           // this._hubservice.showLogin(r.error);
          break;

        }
    // this.mainService.loadingProgressState=30;
  }

  ngOnInit() {}

  closeAction() {
    this.dialogRef.close();
  }

  onSubmit() {
    try {
     // this.validateAllFormFields(this.loginForm);
    //  if (!this.loginForm.invalid) {
        // LoggerService.activityMessage("StartLoginProcess - dialog", this.loginForm.controls["email"].value);
       // this.mainService.loadingProgressState = 1;

       var state = this.hubClientService.connectionLogin.state;
      this.hubClientService.lastLogin = this.loginForm.controls["email"].value;
      if(state =='Disconnected')
      {
          this.hubClientService.connectionLogin
       .start()
       .then(() => {
        this.hubClientService .connectionLogin.send(
          "Login",
          this.loginForm.controls["email"].value,
          this.loginForm.controls["password"].value,
          Intl.DateTimeFormat().resolvedOptions().timeZone
        );
        this.dialogRef.close();
         });
      }
      else
      {
        this.hubClientService .connectionLogin.send(
          "Login",
          this.loginForm.controls["email"].value,
          this.loginForm.controls["password"].value,
          Intl.DateTimeFormat().resolvedOptions().timeZone
        );
        this.dialogRef.close();
      }

     //  .start()
     //  .then(() => {
   //   this.hubClientService.connectionLogin
     //   .start()
     //   .then(() => {

  //        });
    //   })

        // this.userService
        //   .login(
        //     this.loginForm.controls["email"].value,
        //     this.loginForm.controls["password"].value,
        //     this.loginForm.controls["rememberme"].value,
        //     this.url
        //   )
        //   .then((r) => {

        //   })
        //   .catch((e) => {
        //   //  this.mainService.loadingProgressState = 0;
        //     //    LoggerService.activityMessage("LogineError - dialog", this.loginForm.controls["email"].value);
        //     // this.mainService
        //     //   .showErrorSheet(e)
        //     //   .afterDismissed()
        //     //   .subscribe(() => {});
        //   });
    //  }
    } catch (e) {
     // LoggerService.logError(e);
    }
  }

  forgotPassword() {
    this.dialogRef.close();
    this.userService.showLogin();
  }

  validateAllFormFields(formGroup: FormGroup) {
    // {1}
    Object.keys(formGroup.controls).forEach((field) => {
      // {2}
      const control = formGroup.get(field); // {3}
      if (control instanceof FormControl) {
        // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        // {5}
        this.validateAllFormFields(control); // {6}
      }
    });
  }



  @HostListener("window:keyup", ["$event"])
  keyEventUp(event: KeyboardEvent) {
    if (event.keyCode === 13) {
      this.onSubmit();
    }
  }
}
